export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/ob-step-1.png?9b8ba7c08a2ea4a3dc77049a637c6d4a";